import { render } from "./Quotes.vue?vue&type=template&id=6c24fb1e&scoped=true"
import script from "./Quotes.vue?vue&type=script&lang=ts"
export * from "./Quotes.vue?vue&type=script&lang=ts"

import "./Quotes.vue?vue&type=style&index=0&id=6c24fb1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6c24fb1e"

export default script